<template lang="html">
  <div id="Layout">
    <NavBar></NavBar>
    <router-view></router-view>
  </div>
</template>

<script>
  import NavBar from '@/components/NavBar/'
  export default {
    name: 'Layout',
    components: {
      NavBar
    },
    data: () => ({}),
    methods: {}
  }
</script>

<style lang="scss" scoped>
  #Layout {
    /* No scroll and full screen */
    display: flex;
    height: 100%;
    flex-direction: column;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout/index.vue